import BeCuponUtils from "@/utils/Utils";

export default class Company {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        companyRetrieve(id: ${id}) {
          affiliate
          id
          active
          name
          description
          closeTime
          images {
            id
            url
          }
          logo {
            id
            url
          }
          openTime
          phoneNumber
          notifAuth
          notifAmount
          notifExpDate
          notifSent
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.companyRetrieve;
  }

  static async allToCreateCoupon(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        companyList{
          results{
            id
            affiliate
            name
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.companyList.results.reverse();
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        companyList(affiliate:${payload.affiliate}) {
          results{
            id
            affiliate
            name
            description
            images {
              id
              url
            }
            logo {
              id
              url
            }
            openTime
            closeTime
            phoneNumber
            notifAuth
            notifAmount
            notifExpDate
            notifSent      
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i=0; i < response.data.data.companyList.results.length; i++) {
       response.data.data.companyList.results[i].notifAuth = response.data.data.companyList.results[i].notifAuth ? "SI" : "NO";
       response.data.data.companyList.results[i].notifAmount = response.data.data.companyList.results[i].notifAmount !== null ? response.data.data.companyList.results[i].notifAmount : "---";
       response.data.data.companyList.results[i].notifExpDate = response.data.data.companyList.results[i].notifExpDate !== null ? BeCuponUtils.formatDate(response.data.data.companyList.results[i].notifExpDate) : "---";
    }

    return response.data.data.companyList.results.reverse();
  }

  static async filter(payload) {
    const parameters = Object.keys(payload).indexOf('notifAuth') >= 0 ? `active: ${payload.active}, notifAuth: ${payload.notifAuth}` : `active: ${payload.active}`;

    const response = await payload.axios.post(
      '/graphql/',
      `query{
        companyList (${parameters}) {
          results{
            affiliate
            id
            name
            description
            images {
              id
              url
            }
            logo {
              id
              url
            }
            openTime
            closeTime
            phoneNumber
            notifAuth
            notifAmount
            notifExpDate
            notifSent           
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.companyList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteCompany(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteCompany.ok;
  }

  static async create(axios, name, description, openTime, closeTime, phoneNumber, images, logo, affiliate) {
    const imageField = (images !== -1) ? `images: [${images}],` : ``;
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;

      const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");

      const response = await axios.post(
      '/graphql/',
      `mutation{
        createCompany(newCompany: {
          ${imageField}
          ${logoField}
          name: "${name}", 
          description: "${newDescrip}", 
          openTime: "${openTime}",
          closeTime: "${closeTime}",
          affiliate: ${affiliate},
          phoneNumber: "${phoneNumber}"
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createCompany.ok;
  }


  static async edit(axios, id, name, description, openTime, closeTime, phoneNumber, images, logo, affiliate) {
    const imageField = (images !== -1) ? `images: [${images}],` : ``;
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;

    const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");

      const response = await axios.post(
      '/graphql/',
      `mutation{
        updateCompany(newCompany: {
          ${imageField}
          ${logoField}
          id: ${id},
          name: "${name}", 
          description: "${newDescrip}", 
          openTime: "${openTime}",
          closeTime: "${closeTime}",
          phoneNumber: "${phoneNumber}",
          affiliate: ${affiliate},
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateCompany.ok;
  }
}
